import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface FormDeleteProps {
    open: boolean;
    title: string;
    description: string;
    onCancel: () => void;
    onConfirm: () => void;
    names: string | string[];
    textButton: string;
    mode: string;
}

export const FormDelete = ({ open, title, description, onConfirm, onCancel, names, textButton, mode }: FormDeleteProps) => {
    return (
        <>
            <Dialog open={open} onClose={onCancel}>
                <DialogTitle>{title}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => onCancel()}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Typography variant="body1" sx={{ marginBottom: 1 }}>
                        {description}
                    </Typography>
                    {Array.isArray(names) ? (
                        names.map((name, index) => (
                            <Box sx={{ padding: 1 }} component={'span'} key={index}>
                                {name}
                            </Box>
                        ))
                    ) : (
                        <Box sx={{ padding: 1 }} component={'span'}>
                            {names}
                        </Box>
                    )}
                </DialogContent>

                <DialogActions sx={{ pb: 2, pr: 3 }}>
                    <Button variant="contained" disableElevation onClick={() => onConfirm()} color="error">
                        {textButton}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
